import {
  AppBar,
  AppBarProps,
  Box,
  Divider,
  IconButton,
  Stack,
  styled,
  Toolbar,
  useMediaQuery,
  useTheme,
  Typography,
} from "@mui/material";
import { IconMenu2 } from "@tabler/icons-react";
import { FC } from "react";
import { useNavigate, useRouteLoaderData } from "react-router-dom";
import { BASE_NAME } from "../../App";
import { drawerWidth } from "./AppLayout";
import { UserMenu } from "./UserMenu";
import { useLocation } from "react-router-dom";
import { TUser } from "../../services/auth";
import { APP_TITLE } from "../../constants/dashboard";

interface DesktopAppBarProps extends AppBarProps {
  open?: boolean;
}

const DesktopAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<DesktopAppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  ...(!open && {
    marginLeft: theme.spacing(7),
    width: `calc(100% - ${theme.spacing(7)})`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

interface Props extends AppBarProps {
  open?: boolean;
  onMenuClick: () => void;
}

export const AppHeader: FC<Props> = ({
  open,
  onMenuClick,
  position,
  sx,
  ...props
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const basename = BASE_NAME || "";
  const { user } = useRouteLoaderData("root") as { user: TUser };
  const location = useLocation();

  const menuButton = (
    <IconButton
      color="inherit"
      aria-label="open drawer"
      edge="start"
      onClick={onMenuClick}
      sx={{ mr: 2 }}
    >
      <IconMenu2 />
    </IconButton>
  );

  if (isMobile) {
    return (
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          // background: (theme) => theme.palette.background.paper,
          // color: (theme) => theme.palette.text.primary,
          ...sx,
        }}
        {...props}
      >
        <Toolbar>
          {menuButton}
          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="row" spacing={2} flexGrow={0}>
            <UserMenu />
            <Typography sx={{ paddingTop: "10px" }}>
              {user?.name ?? ""}
            </Typography>
          </Stack>
        </Toolbar>
        <Divider />
      </AppBar>
    );
  }

  return (
    <DesktopAppBar
      open={open}
      position="fixed"
      elevation={0}
      sx={{
        //background: (theme) => theme.palette.background.paper,
        //color: (theme) => theme.palette.text.primary,
        backgroundColor: "#ffffff",
        color: "#000000",
        ...sx,
      }}
      {...props}
    >
      <Toolbar>
        <Typography
          variant="h5"
          fontWeight={600}
          color="rgba(0, 0, 0, 0.6)"
          sx={{
            width: "100%",
          }}
        >
          {APP_TITLE.TITLE}
        </Typography>

        {/* <Typography sx={{ paddingTop: '10px' }}>{location.pathname}</Typography> */}

        {/* {menuButton} */}
        <Stack direction="row" spacing={1} flexGrow={1}></Stack>
        <Stack direction="row" spacing={2} flexGrow={0}>
          {/* <SearchBox />
          <Messages items={messages} />
          <Notifications items={notifications} />
          <FullscreenButton /> */}
          <UserMenu />
          <Typography sx={{ paddingTop: "10px" }}>
            {user?.name ?? localStorage.getItem("userName")}
          </Typography>
        </Stack>
      </Toolbar>
      <Divider />
    </DesktopAppBar>
  );
};
